import { createIcon } from "@chakra-ui/react";

export const Worried = createIcon({
  displayName: "Worried",
  viewBox: "0 0 32 32",
  path: [
    <mask
      id="worried-mask"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <path fill="#D9D9D9" d="M0 0h32v32H0z" />
    </mask>,
    <g mask="url(#worried-mask)">
      <path
        fill="#fff"
        d="M2.561 15.3a1.208 1.208 0 0 0-.755 1.521L5.148 26.95l.074.202c.841 2.04 3.669 2.295 4.856.363l.145-.264a2.78 2.78 0 0 0 .142-2.03L8.66 19.74a1.179 1.179 0 0 0-1.492-.776 1.206 1.206 0 0 0-.776 1.51l.678 2.172a.4.4 0 0 1-.258.5.39.39 0 0 1-.496-.253l-2.251-6.84A1.184 1.184 0 0 0 2.56 15.3z"
      />
      <path
        d="M1.17 17.026a1.876 1.876 0 0 1 1.178-2.36 1.85 1.85 0 0 1 2.348 1.177l1.145 3.482c.21-.457.601-.829 1.12-.996a1.846 1.846 0 0 1 2.333 1.212L11 25.02l-.002.001a3.445 3.445 0 0 1-.176 2.513l-.007.017-.01.016-.144.264-.008.016-.01.015c-1.473 2.396-4.992 2.084-6.04-.458l-.003-.012-.006-.01-.074-.203-.004-.012-.004-.01L1.172 17.03l-.002-.005zM2.56 15.3c-.626.209-.96.89-.756 1.52l3.342 10.128.074.203c.841 2.038 3.669 2.294 4.856.363l.145-.265a2.78 2.78 0 0 0 .142-2.03l-1.706-5.48a1.18 1.18 0 0 0-1.492-.776 1.206 1.206 0 0 0-.776 1.51l.678 2.172a.4.4 0 0 1-.258.5.39.39 0 0 1-.496-.253l-2.251-6.84a1.184 1.184 0 0 0-1.503-.752z"
        fill="#2B2C3D"
      />
      <path
        d="M15.999 3.5a12.502 12.502 0 0 1 11.548 7.716 12.5 12.5 0 0 1 .78 2.741 2.513 2.513 0 0 0-1.887 1.677l-.781 2.379a2.524 2.524 0 0 0-.645-.318l-.187-.06-.018.004a2.507 2.507 0 0 0-2.823 1.344l-1.976 6.372a4.11 4.11 0 0 0 .296 2.375c-1.379.507-2.836.77-4.307.77-1.542 0-3.069-.29-4.506-.845.306-.724.4-1.52.266-2.3l-1.975-6.372A2.507 2.507 0 0 0 6.96 17.64l-.018-.005-.188.061c-.235.076-.45.186-.644.318l-.782-2.379a2.511 2.511 0 0 0-1.669-1.622c.154-.957.418-1.896.79-2.796A12.5 12.5 0 0 1 16 3.5zm0 14.167A3.336 3.336 0 0 0 12.665 21v1.667A3.336 3.336 0 0 0 16 26a3.336 3.336 0 0 0 3.333-3.333V21a3.336 3.336 0 0 0-3.333-3.333zM11.853 13.5a.834.834 0 1 0-.002 1.669.834.834 0 0 0 .002-1.669zm8.333 0a.834.834 0 1 0-.002 1.668.834.834 0 0 0 .002-1.668z"
        fill="#fff"
      />
      <path
        d="M11.493 27.654c1.437.556 2.964.845 4.506.845 1.471 0 2.928-.263 4.307-.77.01.023.018.046.029.069l.024.058.019.03.142.26.007.016.012.02.013.02.007.01c.053.086.109.17.166.25a13.327 13.327 0 0 1-4.726.87c-1.698 0-3.36-.326-4.91-.94.041-.059.083-.118.122-.18l.006-.01.013-.02.012-.02.008-.015.142-.26.018-.03.025-.06c.022-.046.038-.095.058-.143z"
        fill="#2B2C3D"
      />
      <path
        d="M15.999 17.666a3.336 3.336 0 0 1 3.333 3.333v1.667a3.336 3.336 0 0 1-3.333 3.333 3.336 3.336 0 0 1-3.334-3.333v-1.667A3.336 3.336 0 0 1 16 17.666zm0 .833a2.5 2.5 0 0 0-2.5 2.5v1.667a2.5 2.5 0 0 0 5 0v-1.667a2.5 2.5 0 0 0-2.5-2.5z"
        fill="#2B2C3D"
      />
      <path
        d="M11.853 13.5a.834.834 0 1 1 .001 1.668.834.834 0 0 1-.001-1.669zM20.186 13.5a.834.834 0 1 1 .002 1.668.834.834 0 0 1-.002-1.669z"
        fill="#2B2C3D"
      />
      <path
        d="M15.999 2.666a13.332 13.332 0 0 1 13.17 11.26 2.504 2.504 0 0 0-.842.03 12.498 12.498 0 0 0-.78-2.74A12.499 12.499 0 0 0 3.66 14.01a2.51 2.51 0 0 0-.828-.105 13.333 13.333 0 0 1 13.167-11.24z"
        fill="#2B2C3D"
      />
      <path
        d="M29.213 15.3c.626.21.96.891.755 1.521L26.627 26.95l-.075.202c-.84 2.04-3.668 2.295-4.856.363l-.144-.264a2.78 2.78 0 0 1-.143-2.03l1.706-5.48c.198-.633.864-.98 1.493-.776.628.203.974.876.776 1.51l-.678 2.172a.4.4 0 0 0 .258.5.39.39 0 0 0 .495-.253l2.252-6.84a1.184 1.184 0 0 1 1.503-.753z"
        fill="#fff"
      />
      <path
        d="M30.601 17.026a1.876 1.876 0 0 0-1.178-2.36 1.851 1.851 0 0 0-2.348 1.177l-1.145 3.482a1.857 1.857 0 0 0-1.12-.996 1.846 1.846 0 0 0-2.333 1.212l-1.707 5.48.002.001a3.446 3.446 0 0 0 .176 2.513l.007.017.01.016.144.264.008.016.01.015c1.473 2.396 4.992 2.084 6.04-.458l.003-.012.006-.01.075-.203.003-.012.004-.01L30.6 17.03l.001-.005zM29.212 15.3c.625.209.959.89.755 1.52l-3.342 10.128-.074.203c-.841 2.038-3.669 2.294-4.856.363l-.145-.265a2.78 2.78 0 0 1-.142-2.03l1.706-5.48c.198-.633.863-.979 1.492-.776.628.203.974.877.776 1.51l-.678 2.172a.4.4 0 0 0 .258.5.39.39 0 0 0 .496-.253l2.251-6.84a1.184 1.184 0 0 1 1.503-.752z"
        fill="#2B2C3D"
      />
    </g>
  ],
  defaultProps: {
    "aria-label": "Screaming with fear emoji"
  }
});

export default Worried;
